var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,1.7c-5.8,0-10.4,4.7-10.4,10.4c0,3.6,1.8,6.9,4.8,8.9V23v0.6v2.9h1v2.9h1v2.9h7.4v-2.9h1v-2.9h1v-2.9l0-2.6 c3-1.9,4.8-5.2,4.8-8.8C27.4,6.4,22.8,1.7,17,1.7z M20.1,31.7h-6.2v-2.3h6.2V31.7z M21,28.8h-0.4h-7.4H13v-2.3H21V28.8z M22,25.9 h-0.4h-9.3H12v-2.3h10V25.9z M15.3,23l-1.2-8.1l1.5,1.1l1.4-1.4l1.4,1.4l1.5-1.1L18.7,23H15.3z M22.2,20.6L22,20.6l0,2.3h-2.7 l1.4-9.3l-0.6-0.1L20,14l-1.5,1.2L17,13.7l-1.5,1.5L14,14l-0.1-0.4l-0.6,0.1l1.4,9.3H12v-2.3l-0.1-0.1c-2.9-1.8-4.7-5-4.7-8.4 c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8C26.8,15.6,25.1,18.7,22.2,20.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.9cba355a42b2a8f61f8c733819f6265d.svg";
export { ForwardRef as ReactComponent };